import { inject, Injectable } from '@angular/core';
import { AccountDTO } from '@core/models/admin/admin-account.types';
import { WebsocketSubscriber } from '@core/services/websocket-subscriber';

import { VoiceConversationEvent } from '../voice.types';
import { VoiceConversationStore } from './voice-conversation.store';

/**
 * Subscribes to `/topic/voice/conversation/{accountId}` and feeds the
 * {@link VoiceConversationStore} so the inbox can react to WAITING_AGENT /
 * PICKED_UP / ENDED transitions. Connected from the inbox shell alongside the
 * other conversation websocket services.
 */
@Injectable({ providedIn: 'root' })
export class VoiceConversationWebsocketService extends WebsocketSubscriber {
    private readonly store = inject(VoiceConversationStore);

    private readonly TOPIC = '/topic/voice/conversation/@accountId';

    protected subscribe(accountId: AccountDTO['account_id']) {
        const destination = this.TOPIC.replace('@accountId', accountId.toString());
        this.client.subscribe(destination, msg => {
            try {
                const event = JSON.parse(msg.body) as VoiceConversationEvent;
                this.store.apply(event);
            } catch {
                /* ignore malformed frames */
            }
        });
    }
}
